import { createFileRoute } from '@tanstack/react-router';

import { ChildSafetyContent } from '@/features/legal/components/childSafetyContent';
import { LegalPageLayout } from '@/features/legal/components/legalPageLayout';

export const Route = createFileRoute('/child-safety')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <LegalPageLayout title="Child Safety Standards">
      <ChildSafetyContent />
    </LegalPageLayout>
  );
}
